import dashboardConstants from "../constants/dashboardConstants";

export const getIncomeSummary = () => ({
  type: dashboardConstants.GET_INCOME_SUMMARY_REQUEST,
});

export const getClientTypeIncome = (payload: any) => ({
  type: dashboardConstants.GET_CLIENT_TYPE_INCOME_REQUEST,
  payload,
});

export const getIncomeChartData = (payload: any) => ({
  type: dashboardConstants.GET_INCOME_CHART_DATA_REQUEST,
  payload,
});

export const getPaymentChartData = (payload: any) => ({
  type: dashboardConstants.GET_PAYMENT_CHART_DATA_REQUEST,
  payload,
});

export const getTopEarningAccount = (payload: any) => ({
  type: dashboardConstants.GET_TOP_EARNING_ACCOUNT_REQUEST,
  payload,
});

export const getTopEarningPlatform = (payload: any) => ({
  type: dashboardConstants.GET_TOP_EARNING_PLATFORM_REQUEST,
  payload,
});
